import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import config from "../../config";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              <span className="purple"> WELCOME </span> TO MY Portfolio
            </h1>
            <p className="home-about-body">
              As a software engineer with many years' experience,{" "}
              <br />
              <br />I specialise in{" "}
              <i>
                <b className="purple"> Java, TypeScript, Swift </b>and{" "}
                <b className="purple">Python.</b>
              </i>
              <br />
              <br />
              Proven expertise in developing&nbsp;
              <i>
                <b className="purple">
                  full-stack web applications, iOS apps,{" "}
                </b>
                and{" "}
                <b className="purple">AI-powered products</b>
              </i>
              &nbsp;with multiple apps published on the App Store.
              <br />
              <br />
              Currently a software developer at{" "}
              <b className="purple">TD Canada Trust</b>, building
              <i>
                <b className="purple"> enterprise solutions</b>
              </i>
              &nbsp;and independently shipping
              <i>
                <b className="purple"> AI-integrated mobile apps</b>
              </i>
              .
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt={`${config.owner.name} avatar`} />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h2 style={{ fontSize: "1.6em" }}>FIND ME ON</h2>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links" aria-label="Social media links">
              <li className="social-icons">
                <a
                  href={config.github.profileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="GitHub profile"
                >
                  <AiFillGithub aria-hidden="true" />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href={config.owner.linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="LinkedIn profile"
                >
                  <FaLinkedinIn aria-hidden="true" />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
